const typography = {
  fontFamily: "Inter",
  h1: {
    fontSize: "34px",
    fontWeight: "bold",
  },
  h2: {
    fontSize: "32px",
    fontWeight: "bold",
  },
  h3: {
    fontSize: "26px",
    fontWeight: "bold",
  },
  h4: {
    fontSize: "2px",
    fontWeight: "bold",
  },
  h5: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  h6: {
    fontSize: "16px",
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: "24px",
    fontWeight: 600,
  },
  subtitle2: {
    fontSize: "18px",
    fontWeight: 500,
  },
  body1: {
    fontSize: "14px",
    fontWeight: 400,
  },
  body2: {
    fontSize: "12px",
    fontWeight: 400,
  },
  fontWeightRegular: 500,
  fontWeightLight: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
};

export default typography;
